import { mapState } from 'vuex';

import { LOCATIONS_NAMESPACE } from '@store/modules/locations.types';

import { MachineCategoriesApiService } from '../../_services/machineCategories.api.service';

import { namespace as MachineCategoriesNamespace } from '../../store.types';

const validateMachineCategoryName = ({ machineCategories, name, currentName = null }) => {
  const machineCategoriesExcludeCurrent = currentName
    ? machineCategories
      .filter(m => m.name !== currentName)
      .map(m => m.name)
    : machineCategories.map(m => m.name);
  let errorMessage = '';
  if (!name) {
    errorMessage = 'Name is required!';
  } else if (machineCategoriesExcludeCurrent.some(m => m === name)) {
    errorMessage = 'This name already used';
  }
  return {
    error: !!errorMessage,
    errorMessages: errorMessage ? [errorMessage] : [],
  };
};

export default {
  name: 'MachineCategoryEditor',

  model: {
    type: 'input',
    prop: 'value',
  },

  props: {
    value: Boolean,
    create: Boolean,
    machineCategory: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      machineCategoryName: '',
    };
  },

  computed: {
    ...mapState(LOCATIONS_NAMESPACE, ['suffix']),

    ...mapState(MachineCategoriesNamespace, ['machineCategories']),

    dialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    title() {
      return this.create
        ? 'Create machine category'
        : `Edit machine category: ${this.machineCategory}`;
    },
    machineCategoryNameErrorConfig() {
      return validateMachineCategoryName({
        machineCategories: this.machineCategories,
        name: this.machineCategoryName,
      });
    },
    isInvalidForm() {
      return this.machineCategoryNameErrorConfig.error;
    },
  },

  watch: {
    value(newValue) {
      if (!newValue) {
        return;
      }

      this.machineCategoryName = this.create ? '' : this.machineCategory;
    },
  },

  methods: {
    submitMachineCategoryForm() {
      const action = this.create
        ? MachineCategoriesApiService.createMachineCategory
        : MachineCategoriesApiService.updateMachineCategory;

      this.$VBlackerTheme.alert.warning({
        text: `${this.create ? 'Create' : 'Update'} machine category?`,
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await action({
            suffix: this.suffix,
            oldName: this.machineCategory,
            name: this.machineCategoryName,
          });
          this.$emit('success');
          this.dialog = false;
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },
    onModalClose() {
      this.machineCategoryName = '';
      this.$emit('update:create', true);
    },
  },
};
